import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
}

export interface HomepageShopByStyles {
    containerWrapper?: InjectableCss;
    title?: InjectableCss;
}

export const homepageShopByStyles: HomepageShopByStyles = {
    containerWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            text-align: center;
            margin-bottom: 40px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-bottom: 24px;
                        `,
                        css`
                            margin-bottom: 24px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    title: {
        css: css`
            color: ${getProp("theme.typography.h2.color")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 32px;
                        `,
                        css`
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 32px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};

const styles = homepageShopByStyles;
export const HomepageShopBy: FC<OwnProps> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.containerWrapper}>
            <Typography variant="h2" {...styles.title}>
                {translate("{0}", fields.title)}
            </Typography>
        </StyledWrapper>
    );
};

const HomepageShopByWidget: WidgetModule = {
    component: HomepageShopBy,
    definition: {
        group: "Basic",
        icon: "image-landscape",
        fieldDefinitions: [
            {
                name: fields.title,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
                displayName: "Title",
            },
        ],
    },
};

export default HomepageShopByWidget;
